/**
 * Will return an object of HTML attributes to spread onto an element that will hide PII in logging/recordings
 *
 * @example
 * const privateAttrs = getPrivateAttributes({ alias: 'Password' })
 * return <input type="password" {...privateAttrs} />
 */
export var getPrivateAttributes = function (opts) {
    var _a = (opts !== null && opts !== void 0 ? opts : {}).alias, alias = _a === void 0 ? 'Private Data' : _a;
    return {
        'data-allytm-private': 'true',
        'data-private': '',
        'data-dd-privacy': 'hidden',
        'data-dd-action-name': alias,
    };
};
//# sourceMappingURL=getPrivateAttributes.js.map